"use client";

import { useState, useEffect } from "react";

import { ThreeLevelSelector } from "@/app/indicators/biblio/(components)/ThreeLevelSelector";
import { IndicatorsContext } from "@/app/indicators/(context)/IndicatorsContext";

import { Spinner } from "@nextui-org/react";
import dynamic from "next/dynamic";

import { useRouter } from "next13-progressbar";
import { fetchAreas } from "@/app/indicators/biblio/actions/areas";
import { fetchDocumentsByArea } from "@/app/indicators/biblio/actions/areas";

const LineChart1 = dynamic(() => import("@/app/charts/LineChart1"), {
  ssr: false,
  loading: () => (
    <div className="flex justify-center items-center w-full h-96">
      <Spinner size="large" label="Cargando resultados" />
    </div>
  ),
});

export default function IndicatorsTrendsPage() {
  const router = useRouter();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [series, setSeries] = useState({});
  const [categories, setCategories] = useState([]);
  // Estas variables guardan los valores seleccionados
  const [level1Value, setLevelValue1] = useState(0);
  const [level2Value, setLevelValue2] = useState(-1);
  const [level3Value, setLevelValue3] = useState(-1);

  // Estas variables guardan los valores de los selectores
  const [dataSelector1, setDataSelector1] = useState([]);
  const [dataSelector2, setDataSelector2] = useState([]);
  const [dataSelector3, setDataSelector3] = useState([]);

  const [loading, setLoading] = useState(false);

  function handleClickInPoint(area, year) {
    router.push(
      `/explore/documents?p=1&f=area_str:"${area}"&f=publication_year:"${year}"`
    );
  }


  useEffect(() => {
    fetchAreas().then((resp) => {
      resp = resp.map(({ index, count, label }) => {
        return {
          index: +index,
          label,
          count,
        };
      });
      setData(resp);
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    const areasIds = filteredData.map(({ index }) => index);
    const areasIdsString = areasIds.map((id) => id.toString().padStart(3, "0"));
    if (areasIdsString.length === 0) {
      return;
    }
    fetchDocumentsByArea(areasIdsString).then((resp) => {
      // Get an array with unique publicationYear values
      let publicationYears = Object.keys(resp[0].documentsByYear);

      setCategories(publicationYears);

      const seriesAux = [];
      resp.forEach(({ labelEs, documentsByYear }) => {
        const data = publicationYears.map((year) => {
          return documentsByYear[year] || 0;
        });

        seriesAux.push({
          name: labelEs,
          data,
        });
      });
      setSeries(seriesAux);
      setLoading(false);
    });
  }, [filteredData]);

  return (
    <IndicatorsContext.Provider
      value={{
        data,
        level1Value,
        level2Value,
        level3Value,
        dataSelector1,
        dataSelector2,
        dataSelector3,
        setFilteredData,
        setLevelValue1,
        setLevelValue2,
        setLevelValue3,
        setDataSelector1,
        setDataSelector2,
        setDataSelector3,
        setLoading,
      }}
    >
      <div className="flex flex-col text-left">
        <ThreeLevelSelector />
        {loading ? (
          <div className="flex justify-center items-center w-full h-96">
            <Spinner size="large" label="Cargando resultados" />
          </div>
        ) : (
          <div className="my-10">
            <LineChart1
              series={series}
              categories={categories}
              handleClickInPoint={handleClickInPoint}
            />
          </div>
        )}
      </div>
    </IndicatorsContext.Provider>
  );
}
